import React from 'react'
import ModalBody from '../Paywall Popup/ModalBody';
import Backdrop from './Backdrop'

const PaywallPopup = (props) => {
  return (
    <div className='popup-wrapper'>
      <Backdrop onClick={props.onClick}/>
      <ModalBody id={props.id}/>
    </div>
  )
}

export default PaywallPopup
